import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";

const id = "modal-delete-automation";

// Deleting is permanent from the coach's side: the confirmation says who will exit
const DeleteAutomation = ({ detail, returnTo }) => {
  const { t } = useTranslation("coaching-portal");
  const tr = (key, options) =>
    t(`emailAutomations.deleteModal.${key}`, options);
  const { automation, peopleInside } = detail ?? {};
  if (!automation) return null;

  return (
    <form
      action={`/actions/automations/${automation._id}/delete`}
      method="POST"
      data-noreset
    >
      <input type="hidden" name="returnTo" value={returnTo} />
      <Modal
        name={id}
        key={id}
        header={false}
        className="ea-modal ea-modal--confirm ea-modal--delete"
      >
        <div className="body">
          <img
            className="ea-modal__icon"
            src="/img/new-icons/red-trash.svg"
            alt=""
            aria-hidden="true"
          />
          <h2 className="ea-modal__title">{tr("title")}</h2>
          <p className="ea-modal__lead">
            {peopleInside > 0
              ? tr("body", { name: automation.name, count: peopleInside })
              : tr("bodyNoOne", { name: automation.name })}
          </p>
        </div>
        <footer className="foot">
          {/* biome-ignore lint/a11y/useSemanticElements: a real link so Rill navigates; role only picks up button styles */}
          <a //NOSONAR
            href="/actions/refresh?modal=&automation="
            data-button-type="secondary"
            data-action="cancel"
            role="button"
          >
            {tr("cancel")}
          </a>
          <button type="submit" data-button-type="danger">
            {tr("confirm")}
          </button>
        </footer>
      </Modal>
    </form>
  );
};

DeleteAutomation.propTypes = {
  detail: PropTypes.shape({
    automation: PropTypes.object,
    peopleInside: PropTypes.number,
  }),
  returnTo: PropTypes.string.isRequired,
};

export default DeleteAutomation;
